import styled, {
  keyframes,
} from 'styled-components';

const flash = keyframes`
  0% {
    background: #fafafa;
  }

  50% {
    background: rgba(23, 43, 77, 0.1);
  }

  100% {
    background: #fafafa;
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  flex: 0 0 70px;
  border-top: 1px solid ${props => (props.highlight ? '#c1c1c1' : '#f1f1f1')};
  border-right: 1px solid ${props => (props.highlight ? '#c1c1c1' : '#f1f1f1')};
  box-sizing: border-box;

  animation-name: ${flash};
  animation-delay: ${props => props.delay || '1s'};
  animation-duration: 1s;
  animation-iteration-count: ${props => (props.fetching ? 'infinite' : 0)};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(0, 0, 0, .3);
    display: ${props => (props.highlight ? 'block' : 'none')};
  }

  background: ${(props) => {
    switch (props.type) {
      case 'populated':
        return '#90b9d6';
      case 'today':
        return '#dee4e9';
      case 'week':
        return '#fafafa';
      default:
        return '#fff';
    }
  }}
`;

export const CellData = styled.div`
  display: flex;
  flex-flow: row nowrap;
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
`;
